import { render, staticRenderFns } from "./MifareCardManagement.vue?vue&type=template&id=56530b53&scoped=true"
import script from "./MifareCardManagement.vue?vue&type=script&lang=js"
export * from "./MifareCardManagement.vue?vue&type=script&lang=js"
import style0 from "./MifareCardManagement.vue?vue&type=style&index=0&id=56530b53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56530b53",
  null
  
)

export default component.exports